import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['text', 'labelVisible', 'labelHidden', 'button'];
  static values = { visible: { type: Boolean, default: true } };

  toggle() {
    this.visibleValue = !this.visibleValue;
  }

  visibleValueChanged() {
    this.textTargets.forEach((el) => el.classList.toggle('hidden', !this.visibleValue));
    this.buttonTargets.forEach((el) => el.setAttribute('aria-expanded', String(this.visibleValue)));
    this.labelVisibleTargets.forEach((el) => {
      el.classList.toggle('flex', this.visibleValue);
      el.classList.toggle('hidden', !this.visibleValue);
    });
    this.labelHiddenTargets.forEach((el) => {
      el.classList.toggle('flex', !this.visibleValue);
      el.classList.toggle('hidden', this.visibleValue);
    });
  }
}
